import Vue from 'vue'
import Router from 'vue-router'
import publico from './portal/publico'
import arrecadacao from './arrecadacao'
import financeiro from './financeiro'
import analise from './analise'
import receptor from './receptor'
import portalSeguranca from './portalSeguranca'
import assinatura from './assinatura'
import demandas from './demandas'
import store from '@/store'
import central from './central'
import relatorios from './relatorios'
import PERFIL from '@/constants/perfil'
import produtividade from './produtividade'
import ouvidoria from './ouvidoria'
import relatoriosReurb from './relatorios_reurb'
import relatoriosOuvidoria from './relatorios_ouvidoria'
import salaSituacao from './salaSituacao'
import manutencao from './manutencao'
import diagnostico from './diagnostico'
import gestaoSicarf from './gestaoSicarf'

// DADOS PARAMETRIZADOS POR ESTADO
const MENU = require('@/constants/' + process.env.ESTADO + '/menu').MENUS

Vue.use(Router)

const router = new Router({
  routes: [
    ...publico,
    ...arrecadacao,
    ...financeiro,
    ...central,
    ...analise,
    ...portalSeguranca,
    ...assinatura,
    ...relatorios,
    ...demandas,
    ...produtividade,
    ...receptor,
    ...ouvidoria,
    ...relatoriosReurb,
    ...relatoriosOuvidoria,
    ...salaSituacao,
    ...manutencao,
    ...diagnostico,
    ...gestaoSicarf
  ]
})

const redirecionarUsuario = (usuario, perfis, next, name) => {
  const usuarioTemPermissao = perfis ? perfis.indexOf(usuario.perfilSelecionado.codigo) !== -1 : true

  if (usuarioTemPermissao) {
    next()
  } else {
    next('/' + usuario.perfilSelecionado.paginaInicial ? usuario.perfilSelecionado.paginaInicial : 'selecionarModulo')
  }

  return usuarioTemPermissao
}

const selecionarMenuUsuario = async (usuario, next, to) => {
  const MODULO = await PERFIL[usuario.moduloSelecionado.codigo]
  if (!MODULO) {
    return
  }

  if (usuario.perfilSelecionado.modulo === 'DIAGNOSTICO') {
    let menu = await MENU[MODULO[usuario.perfilSelecionado.modulo].codigo]

    if (to.meta && to.meta.isSubmenu) {
      menu = menu.filter(item => item.routeGroup === to.meta.parentRouteGroup)[0].subMenu
    }
    store.dispatch('menu/setMenu', menu)
    return
  }

  if (!MODULO[usuario.perfilSelecionado.codigo]) {
    return
  }

  let menu = await MENU[MODULO[usuario.perfilSelecionado.codigo].codigo]

  if (to.meta && to.meta.isSubmenu) {
    menu = menu.filter(item => item.routeGroup === to.meta.parentRouteGroup)[0].subMenu
  }

  store.dispatch('menu/setMenu', menu)
}

const verificarModuloUsuario = async (to, from, next) => {
  let usuario = await store.dispatch('auth/getUsuario')

  if (usuario) {
    store.commit('auth/SET_USUARIO', usuario)
    if (usuario.perfilSelecionado) {
      await store.dispatch('auth/setPermissoes')
    }

    if (usuario.perfilSelecionado) {
      selecionarMenuUsuario(usuario, next, to)
      redirecionarUsuario(usuario, to.meta.perfis, next, to.name)
    } else {
      next()
    }
  } else {
    next('/login')
  }
}

const isAuthenticated = async (to, from, next) => {
  if (to.meta.isPublic) {
    next()
    return
  }

  verificarModuloUsuario(to, from, next)
}

router.beforeEach(async (to, from, next) => {
  const token = new URL(location.href).searchParams.get('token')
  if (token) {
    store.dispatch('auth/setToken', token)
    window.location.href = process.env.ROOT_URL + '#/selecionarModulo'
    return
  }
  isAuthenticated(to, from, next)
  Vue.nextTick(() => {
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
    if (nearestWithTitle) {
      document.title = nearestWithTitle.meta.title
    }
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js